import PropTypes from 'prop-types'
import { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { resetModal } from 'slices/modalSlice'
import { GenericGrid } from './GenericGrid'
import { GenericInputs } from './GenericInputs'
import { GenericItems } from './GenericItems'
import styles from './GenericModal.module.css'

export const GenericModal = ({
  onClose = () => {},
  onConfirm = () => {},
  onSelect = () => {},
  onDelete = null,
  onDeleteAll = null,
  onChange = () => {},
  onAddItem = () => {},
  onRemoveItem = () => {},
  onCopyField = () => {},
  ocultarGrid = false,
  component = null,
  modalId = null
}) => {
  const [submitting, setSubmitting] = useState(false)
  const dispatch = useDispatch()

  const {
    show,
    size,
    body,
    items,
    type,
    campos,
    errores,
    editMode,
    values,
    title,
    modalId: activeModalId
  } = useSelector((state) => state.genericModal)

  const esVisible = show && (modalId ? activeModalId === modalId : !activeModalId)
  const soloLectura = Boolean(values?.deshabilitado)

  const handleConfirm = async () => {
    if (soloLectura) {
      handleClose()
      return
    }

    setSubmitting(true)
    const sinErrores = await onConfirm()
    if (!sinErrores) {
      setSubmitting(false)
      return
    }
    setSubmitting(false)
    handleClose()
  }

  const handleClose = () => {
    onClose()
    dispatch(resetModal())
  }

  return (
    <Modal show={esVisible} onHide={handleClose} centered size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <GenericItems
          items={items}
          body={body}
          onSelect={onSelect}
          onDelete={onDelete}
          onDeleteAll={onDeleteAll}
          onClose={handleClose}
        />
        <>
          {type === 'form' ? (
            <>
              <div className={styles.lista}>
                {campos.map((content) => {
                  const value = values?.[content.name] ?? ''
                  return (
                    !content.isGrid && (
                      <GenericInputs
                        key={content.name}
                        content={content}
                        value={value}
                        onChange={onChange}
                        errores={errores}
                        editMode={editMode}
                        readOnly={soloLectura}
                      />
                    )
                  )
                })}
              </div>
              {!ocultarGrid && (
                <GenericGrid
                  campos={campos}
                  values={values}
                  errores={errores}
                  editMode={editMode}
                  onAddItem={onAddItem}
                  onRemoveItem={onRemoveItem}
                  onChangeItem={onChange}
                  onCopyField={onCopyField}
                  readOnly={soloLectura}
                />
              )}
            </>
          ) : type === 'jsx' && component ? (
            component
          ) : null}
        </>
        {errores?.general && (
          <div className="alert alert-danger" role="alert">
            {errores.general}
          </div>
        )}
      </Modal.Body>
      {type === 'mensaje' && (
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose} disabled={submitting}>
            Entendido
          </Button>
        </Modal.Footer>
      )}
      {(type === 'botones' || type === 'form') && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={submitting}>
            {soloLectura ? 'Cerrar' : 'Cancelar'}
          </Button>
          {!soloLectura && (
            <Button variant="primary" onClick={handleConfirm} disabled={submitting}>
              {modalId === 'pedir-presupuesto'
                ? 'Iniciar Presupuesto'
                : type === 'botones'
                  ? 'Aceptar'
                  : 'Guardar'}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
}

GenericModal.propTypes = {
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteAll: PropTypes.func,
  onAddItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
  onCopyField: PropTypes.func,
  ocultarGrid: PropTypes.bool,
  component: PropTypes.node,
  modalId: PropTypes.string
}
